const files = require.context('./', false, /[A-Za-z0-9-_,\s]+\.json$/i);
const locales = {};

files.keys()
  .forEach(key => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);

    if(matched && matched.length > 1) {
      const fileName = matched[1];
      locales[fileName] = files(key)
    }
  });

export default locales;
